module.exports = __webpack_public_path__ + "static/media/release.notes.191e7e69.md";